import React from "react";
import { TableRowField } from "../../../components";
import { formatHelper } from "../../../common/helpers";
import { roles } from "../../../common/constants";
import { Button } from "reactstrap";

export const franchiseReportXS = (role, onClickButton = item) => [
  {
    dataField: "xs",
    text: "Franquicia",
    formatter: (cell, row) => {
      return (
        <div>
          <TableRowField label="Nombre:" value={row.name} />
          <TableRowField
            label="Venta (S/):"
            value={formatHelper.toMoney(row.total_sell)}
          />
          <TableRowField
            label="Franquicia (S/):"
            value={formatHelper.toMoney(row.franchise)}
          />
          <TableRowField
            label="Publicidad (S/):"
            value={formatHelper.toMoney(row.publicity)}
          />
          <TableRowField
            label="Tecnología (S/):"
            value={formatHelper.toMoney(row.technology)}
          />
          <TableRowField
            label="Total (S/):"
            value={formatHelper.toMoney(row.total)}
          />
        </div>
      );
    }
  },
  {
    dataField: "option",
    hidden: role != roles.ACCOUNTANT,
    text: "",
    formatter: (cell, row) => {
      return (
        <div style={{ display: "flex" }}>
          <Button
            color="primary"
            className="display-inline"
            style={{ margin: "0 auto" }}
            onClick={() => {
              onClickButton(row);
            }}
          >
            Facturar
          </Button>
        </div>
      );
    }
  }
];

export const franchiseReportSM = (role, onClickButton = item) => [
  {
    dataField: "sm",
    text: "Franquicia",
    formatter: (cell, row) => {
      return (
        <div>
          <TableRowField label="Nombre:" value={row.name} />
        </div>
      );
    }
  },
  {
    dataField: "total_sell",
    text: "Venta (S/)",
    formatter: cell => {
      return <span>{formatHelper.toMoney(cell)}</span>;
    }
  },
  {
    dataField: "franchise",
    text: "Franquicia (S/)",
    formatter: cell => {
      return <span>{formatHelper.toMoney(cell)}</span>;
    }
  },
  {
    dataField: "publicity",
    text: "Publicidad (S/)",
    formatter: cell => {
      return <span>{formatHelper.toMoney(cell)}</span>;
    }
  },
  {
    dataField: "technology",
    text: "Tecnología (S/)",
    formatter: cell => {
      return <span>{formatHelper.toMoney(cell)}</span>;
    }
  },
  {
    dataField: "total",
    text: "Total (S/)",
    formatter: cell => {
      return <span>{formatHelper.toMoney(cell)}</span>;
    }
  },
  {
    dataField: "option",
    hidden: role != roles.ACCOUNTANT,
    text: "",
    formatter: (cell, row) => {
      return (
        <div style={{ display: "flex" }}>
          <Button
            color="primary"
            className="display-inline"
            style={{ margin: "0 auto" }}
            onClick={() => {
              onClickButton(row);
            }}
          >
            Facturar
          </Button>
        </div>
      );
    }
  }
];

export const franchiseReport = (role, onClickButton = item) => [
  {
    dataField: "name",
    text: "Nombre"
  },
  {
    dataField: "total_sell",
    text: "Venta (S/)",
    formatter: cell => {
      return <span>{formatHelper.toMoney(cell)}</span>;
    }
  },
  {
    dataField: "franchise",
    text: "Franquicia (S/)",
    formatter: cell => {
      return <span>{formatHelper.toMoney(cell)}</span>;
    }
  },
  {
    dataField: "publicity",
    text: "Publicidad (S/)",
    formatter: cell => {
      return <span>{formatHelper.toMoney(cell)}</span>;
    }
  },
  {
    dataField: "technology",
    text: "Tecnología (S/)",
    formatter: cell => {
      return <span>{formatHelper.toMoney(cell)}</span>;
    }
  },
  {
    dataField: "total",
    text: "Total (S/)",
    formatter: cell => {
      return <span>{formatHelper.toMoney(cell)}</span>;
    }
  },
  {
    dataField: "option",
    hidden: role != roles.ACCOUNTANT,
    text: "",
    formatter: (cell, row) => {
      return (
        <div style={{ display: "flex" }}>
          <Button
            color="primary"
            className="display-inline"
            style={{ margin: "0 auto" }}
            onClick={() => {
              onClickButton(row);
            }}
          >
            Facturar
          </Button>
        </div>
      );
    }
  }
];



// WEBPACK FOOTER //
// ./src/scenes/Dashboard/Franchise/_columns.js